import React from "react";
import BaseReactSelectDropdown from "./BaseReactSelectDropdown";
import { type DropdownWithoutOptionsProps } from "../models";

const VenueCategoryDropdown = (props: DropdownWithoutOptionsProps<server.dto.VenueCategory, server.dto.VenueCategories>) => {
  return <BaseReactSelectDropdown
    value={props.value}
    onChange={props.onChange}
    options={serverReference.venueCategories}
    getLabel={venueCategory => venueCategory.text}
    getValue={venueCategory => venueCategory.value}
    excludeKeys={props.excludeKeys}
    config={{
      isSearchable: true,
      ...props.config
    }}
  />;
};

export default VenueCategoryDropdown;